import { z } from 'zod'
import { withMeta, type ZodTypeWithMeta } from './zodType'

export type KeysAndLabels<Keys extends string> = {
  [Key in Keys]: string
}

export type EnumeratedType<Keys extends string, Labels extends Record<Keys, string>> = z.ZodEnum<
  [Keys, ...Keys[]]
> &
  ZodTypeWithMeta & {
    keysAndLabels?: Labels
  }

export function enumerated<const T extends Record<string, string>>(keysAndLabels: T) {
  type Key = keyof T & string
  const keys = Object.keys(keysAndLabels) as Key[]
  const baseEnum = z.enum(keys as [Key, ...Key[]])
  const enumWithMeta = withMeta(baseEnum).meta({ keysAndLabels }) as unknown as EnumeratedType<
    Key,
    T
  >

  enumWithMeta.keysAndLabels = keysAndLabels

  return enumWithMeta
}
